/**
 * @class ActivitiesService
 */
function ActivitiesService($log) {
    var self = this;

    self.ACTIVITIES = [
        'TABAC',
        'PRESSE',
        'BAR',
        'LOTO',
        'GRATTAGE',
        'LIBRAIRIE',
        'PMU',
        'CADEAUX',
        'PAPETERIE',
        'RELAIS_COLIS',
        'BRASSERIE',
        'EPICERIE',
        'BOULANGERIE',
        'KIOSQUE',
        'FLEURISTE',
        'TPE IDMO',
        'VAP',
        'SUPERETTE',
        'RESTAURANT',
        'HOTEL',
        'AUTRE ACTIVITE',
        'CYCLE',
        'MOTO',
        'MOTOCULTEUR',
        'ALIMENTATION',
        'TRANSFERT ARGENT'
    ];

    /**
     * Get activities list
     */
    self.list = function() {
        return self.ACTIVITIES.sort();
    };

    return self;
}
ActivitiesService.$inject = ['$log'];

angular.module('app.prospection.store.activitiesService', []).factory('activitiesService', ActivitiesService);
